import { Flex, Text } from "@radix-ui/themes";
import i18next from "i18next";
import { FC, useEffect } from "react";
import { PrecisionGameUISuccessProps } from "../models/precisionGame.types";
import confetti from "canvas-confetti";

const PrecisionGameUISuccess: FC<PrecisionGameUISuccessProps> = ({
  success,
}): JSX.Element => {
  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  useEffect(() => {
    if (success) {
      const defaults = {
        angle: randomInRange(25, 180),
        spread: randomInRange(40, 80),
        particleCount: randomInRange(50, 100),
        origin: { y: 0.6 },
      };

      // Fire confetti immediately on success
      confetti({
        ...defaults,
      });

      // Set up interval for additional confetti bursts
      const intervalId = setInterval(() => {
        // Randomize each confetti burst
        confetti({
          ...defaults,
          angle: randomInRange(25, 180),
          spread: randomInRange(40, 80),
          particleCount: randomInRange(50, 100),
        });
      }, 2000);

      // Clear the interval after 20 seconds
      setTimeout(() => {
        clearInterval(intervalId);
      }, 20000);

      // Clean up interval on component unmount
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [success]);

  if (success) {
    return (
      <Flex justify="center" my="4">
        <Text>{i18next.t("precisionGame.congrats")} </Text>
      </Flex>
    );
  }

  return null;
};

export default PrecisionGameUISuccess;
